import { isParagraph } from "datocms-structured-text-utils";
import React from "react";
import {
  renderMarkRule,
  renderNodeRule,
  StructuredTextDocument,
} from "react-datocms/structured-text";
import StructuredText from "./datocms/StructuredText";
import { useCampaignTheme } from "../providers/CampaignThemeProvider";

interface Props {
  data: StructuredTextDocument;
}

const StructuredTextForPageTitle = ({ data }: Props) => {
  const { hex } = useCampaignTheme();
  const themeColor = hex ?? "#2AA294";
  return (
    <StructuredText
      data={data}
      customNodeRules={[
        renderNodeRule(isParagraph, ({ children, key }) => {
          return <h1 key={key}>{children}</h1>;
        }),
      ]}
      customMarkRules={[
        renderMarkRule("highlight", ({ children, key }) => {
          return (
            <span key={key} className="font-bold" style={{ color: themeColor }}>
              {children}
            </span>
          );
        }),
        renderMarkRule("strong", ({ children, key }) => {
          return (
            <span key={key} className="font-bold">
              {children}
            </span>
          );
        }),
      ]}
    />
  );
};

export default StructuredTextForPageTitle;
